import {ContactDataModel} from '../../models/person/contact-data.model';
import {AppointmentFlagDataModel} from '../../models/appointments/appointment-flag-data.model';
import {PatientFlagDataModel} from '../../models/patient/patient-flag-data.model';

export interface IAppointment {
  AppointmentId: string;
  PatientId: string;
  PatientName: string;
  StartDateTime: string;
  EndDateTime: string;
  enumApptTypeId: string;
  vcURL: string;
  dataContact: ContactDataModel;
}

export class Appointment implements IAppointment {
  AppointmentId: string;
  PatientId: string;
  PatientName: string;
  StartDateTime: string;
  EndDateTime: string;
  enumApptTypeId: string;
  // enumAppStatusId: string;
  vcURL: string;
  OperatoryId: string;
  dataContact: ContactDataModel;
  teeth: string[];
  dataAppointmentFlags: AppointmentFlagDataModel[] = [];
  DoctorId: string;
  PatientCaseId: string;
  PatientImageUrl: string;

  // Front end only
  dataPatientFlags: PatientFlagDataModel[] = [];
  isCheckedIn: boolean = false;
  isDeceased: boolean = false;
  isDoNotEverTreatAgain = false;
  isTodayAppointment: boolean = true;

  constructor(data?: IAppointment) {
    if (data) {
      for (let property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
}
